import { useState } from "react"; 
import { UserAvatar } from "../../components/Component";
import { getSmartInitials } from "../../utils/Utils";

export const UserAvatarCell = ({ row,name,image,setValue,handleImageOpenPreview }) => {
  const [imageError, setImageError] = useState(false);

  if (!image || imageError) {
    return (
      <UserAvatar 
        theme="primary"
        text={getSmartInitials(name)}
      />
    );
  }

  return (
    <img
      src={image}
      alt={name || "User"}
      style={{
        width: "45px",
        height: "45px",
        borderRadius: "50%",
        objectFit: "cover",
        border: "2px solid #e5e7eb",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        cursor: handleImageOpenPreview ? "pointer":"default",
      }}
      onClick={() => handleImageOpenPreview?  handleImageOpenPreview(image):null}
      onError={() => setImageError(true)}
    />
  );
};
